import { DocumentationLegacyPageBlockText, } from "./SDKDocumentationLegacyPageBlockText";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockCallout extends DocumentationLegacyPageBlockText {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.calloutType = model.calloutType;
    }
}
